import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useOutletContext } from 'react-router-dom';
import { toast } from 'react-toastify';
import { format } from 'date-fns';
//api
import { createPromoCode } from 'api/invoice';
//components
import Title from 'components/backoffice/texts/title';
import PromoCodeForm from 'components/backoffice/forms/promoCodeForm';

const CreatePromotionalCodes = () => {
  const { t } = useTranslation(['backoffice']);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const {setTitle} = useOutletContext()

  useEffect(()=>{
    setTitle(t('createpromotionalcode'))
    return () => {
      setTitle(''); 
    };
  },[setTitle])

  const onSubmit = async (values) => {
    setLoading(true);
    const sendValues = {
      title: values.title,
      code: values.code,
      start: format(values.start, 'yyyy-MM-dd HH:mm'),
      end: format(values.end, 'yyyy-MM-dd HH:mm'),
      discount_percent: values.discount_percent ? values.discount_percent : null,
      discount_amount: values.discount_amount ? values.discount_amount : null,
      max_redemptions: values.max_redemptions,
      max_redemptions_per_user: values.max_redemptions_per_user,
      active: values.active,
      libraries: values.libraries
        ? values.libraries.map((el) => {
            return el.value.toString();
          })
        : [],
    };
    try {
      const { status } = await createPromoCode(sendValues);
      if (status === 200 || status === 201) {
        toast.success(t('creadocorrectamente'));
        navigate(-1);
      } else toast(`${t('error')} ${status}: ${t('mensajeerror')}`);
    } catch (error) {
      console.error('Error en onCreate:', error);
    }
    setLoading(false);
  };

  return (
    <div>
      <Title text={t('createpromotionalcode')} />
      <PromoCodeForm onSubmit={onSubmit} promoCode={{}} loading={loading} isEditing={false} />
    </div>
  );
};

export default CreatePromotionalCodes;
